/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ScheduleOverrideAction = typeof ScheduleOverrideAction[keyof typeof ScheduleOverrideAction];


export const ScheduleOverrideAction = {
  record: 'record',
  skip: 'skip',
} as const;
